import React from 'react';
import { numberWithCommas } from 'app/libs/number';
import classNames from 'classnames/bind';
import styles from './PaymentChargeLayer.module.scss';

const cx = classNames.bind(styles);

const PaymentChargeLayer = ({
	selectedYearMonth,
	isQuarter = false,
	isCarryoverMonth = false,
	contractAmount,
	extraAmount,
	totalAmount,
	consultantAdjustmentAmount = undefined,
}) => {
	const [, month] = selectedYearMonth;
	const currentQuarter = Math.ceil(Number(month) / 3);
	const prevQuarter = currentQuarter - 1 || 4;

	return (
		<div className={cx('wrap_payment')}>
			<ul className={cx('list_payment')}>
				<li className={cx('item_prepayment')}>
					<p className={cx('tit_payment')}>{month}월 제휴상품 선납금액</p>
					<p className={cx('txt_price')}>{numberWithCommas(contractAmount)}원</p>
				</li>
				{!isCarryoverMonth && (
					<li className={cx('item_exceedpayment')}>
						<p className={cx('tit_payment')}>
							{isQuarter && !isCarryoverMonth ? `${prevQuarter}분기 초과상품 금액` : `${month - 1 || 12}월 초과상품 금액`}
						</p>
						<p className={cx('txt_price', { plus: extraAmount > 0, minus: extraAmount < 0 })}>{numberWithCommas(extraAmount)}원</p>
					</li>
				)}
				{Number(consultantAdjustmentAmount) !== 0 && (
					<li className={cx('item_consultant')}>
						<p className={cx('tit_payment')}>컨설턴트 조정 금액</p>
						<p className={cx('txt_price', { plus: consultantAdjustmentAmount > 0, minus: consultantAdjustmentAmount < 0 })}>
							{numberWithCommas(Math.abs(consultantAdjustmentAmount))}원
						</p>
					</li>
				)}
			</ul>
			<div className={cx('box_total')}>
				<p className={cx('tit_total')}>총 구매비용</p>
				<p className={cx('txt_total')}>{numberWithCommas(totalAmount)}원</p>
			</div>
		</div>
	);
};

export default PaymentChargeLayer;
